import React, { useState } from "react";
import TableOuterLabel from "../../../components/Table/TableOuterLabel";
import Table from "../../../components/Table/Table";
import QuizListTr from "./QuizListTr";
import {
  useDeleteQuizMutation,
  useGetQuizzesQuery,
} from "../../../features/Admin/Quizzes/quizzesApi";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";

const headers = ["Question", "Video", "Action"];
export default function Quizzes() {
  // *****************************************************DECLARATION START******************************************************************************
  const { data: quizzes, isLoading, isError } = useGetQuizzesQuery();
  const [deleteQuiz, { isError: deleteQuizIsError }] = useDeleteQuizMutation();
  // *****************************************************DECLARATION END******************************************************************************

  // *****************************************************HANDLE START******************************************************************************
  const handleDelete = (qId) => {
    deleteQuiz(qId);
  };
  // *****************************************************HANDLE END******************************************************************************

  // *****************************************************Decided which part render START******************************************************************************

  let content = null;
  let contentLoadingOrError = null;
  if (isLoading) {
    contentLoadingOrError = <Loading />;
  } else if (!isLoading && (isError || deleteQuizIsError)) {
    contentLoadingOrError = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!isLoading && !isError && quizzes?.length === 0) {
    contentLoadingOrError = <Error header="" message="No quiz available" />;
  } else if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((row, index) => (
      <QuizListTr
        key={`${row?.id}_${index}`}
        row={row}
        handleDelete={handleDelete}
      />
    ));
  }
  content = contentLoadingOrError ? (
    contentLoadingOrError
  ) : (
    <Table headers={headers}>{content}</Table>
  );
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <TableOuterLabel btnText={"Add Quiz"} to="/admin/addQuizze" />
      <div className="overflow-x-auto mt-4">{content}</div>
    </>
  );
}
